import { Box, styled } from '@mui/material';

const StepperRowMain = styled(Box)`
  flex-grow: 1;
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
`;

export default StepperRowMain;
